export default __webpack_public_path__ + "static/media/jpg.bbcc5141.svg";